const formatter = new Intl.NumberFormat('en-AU', {
	style: 'currency',
	currency: 'AUD',
});

export const formatMoney = (value) => {
	return formatter.format(value);
};
